import React from 'react';
import PropTypes from 'prop-types';

// Containers
import { PAYPAL_THEME } from '@paypalcorp/pp-react';
import { ThemeProvider } from '@emotion/react';
import SessionHandler from '../containers/SessionHandler';
import HeroModuleSession from '../containers/HeroModule';

// PPUI

/**
 * Help Template to show hero module and handle SessionHandler
 * @param {Object} props   the children component for for channelsteering page
 */
const HelpTemplate = function (props) {
  return (
    <div>
      <div className="vx_mainContent" role="main">
        <SessionHandler />
        <ThemeProvider theme={PAYPAL_THEME}>
          <HeroModuleSession />
          {props.children}
        </ThemeProvider>
      </div>
    </div>
  );
};

// Property Types
HelpTemplate.propTypes = {
  children: PropTypes.element.isRequired,
};

export default HelpTemplate;
